import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import PayrollRecord from "../../../classes/PayrollRecord";

export default {
  routes: [
    {
      name: "payroll-history",
      path: "history",
      meta: {
        auth: () => PayrollRecord.canBeViewedBy(store.state.main.user),
        icon: "payroll",
        title: i18n.global.t("Payroll History"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
      },
      component: () => import("pages/admin/PayrollHistory"),
    },
    {
      name: "payroll-history-search",
      path: "history/search/:query?",
      meta: {
        auth: () => PayrollRecord.canBeViewedBy(store.state.main.user),
        icon: "payroll",
        title: i18n.global.t("Payroll History"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
        hideFromIndex: true,
      },
      component: () => import("pages/admin/PayrollHistory"),
    },
  ],

  dialogs: [],
};
